// extracted by mini-css-extract-plugin
export default {"root":"o7Uk_JU9Ct6iG3i2pnlM","link":"gFP7a3pLdCB01m5PxNS5","active":"PRfxnwsaBDFSfBMnPEmC","linkContent":"pgj9eSlqTwnbLwlpcB6r","placeHolderShimmer":"S8GTiHRYsyWQEstfbjuK"};